import { useState, useCallback, useEffect } from "react";

// Global shared state for scheduled date
let globalScheduledDate = null;
let listeners = new Set();

const notifyListeners = () => {
  listeners.forEach((listener) => listener());
};

// Hook to manage selected date from calendar for scheduling posts
const useScheduledDate = () => {
  const [, forceUpdate] = useState({});

  useEffect(() => {
    const listener = () => {
      forceUpdate({});
    };
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  const setScheduledDate = useCallback((date) => {
    globalScheduledDate = date;
    notifyListeners();
  }, []);

  const getScheduledDate = useCallback(() => {
    return globalScheduledDate;
  }, []);

  const clearScheduledDate = useCallback(() => {
    globalScheduledDate = null;
    notifyListeners();
  }, []);

  return {
    scheduledDate: globalScheduledDate,
    setScheduledDate,
    getScheduledDate,
    clearScheduledDate,
  };
};

export default useScheduledDate;
